import { HttpClient } from "@angular/common/http";
import { inject, Injectable } from "@angular/core";
import { API_URL } from "@equine-ui-nx/injection-tokens";

@Injectable()
export class DonationsExposedService {

  private http = inject(HttpClient);
  private apiUrl = inject(API_URL);
  // private apiUrl = `http://localhost:8080/api`

  getDonationById(id: string) {
    const GET_DONATION_BY_ID = `donations/getDonationById`;

    return this.http.post(`${this.apiUrl}/${GET_DONATION_BY_ID}`, {id});
  }
  
  getDonationsByUserId(payerReference: string, pageSize: number, pageIndex: number) {
    const DONATIONS_TABLE = `donations/getDonationsTableByPayorId`;

    const payload = {
      payorId: payerReference,
      pageSize,
      pageIndex
    };

    return this.http.post(`${this.apiUrl}/${DONATIONS_TABLE}`, payload);
  }

  changeSubscriptionState(action: string, donationLogId: string, reason: string) {
    const CHANGE_SUBSCRIPTION_STATE = `paymentDonations/changeSubscriptionState`;

    return this.http.post<{ok: boolean}>(`${this.apiUrl}/${CHANGE_SUBSCRIPTION_STATE}`, {
      action, donationLogId, reason
    });
  }

}